/**
 * 活动类型常量
 * 后续如果切换到新活动，只需修改 CURRENT_POWER_ACTIVITY_TYPE。
 */
export const ACTIVITY_TYPE = {
  /** 春季焕新活动 */
  FREE_CANVAS: "free_canvas",
  /** 618 促销活动（与后端 getActivityRights 下发的 type 一致） */
  PROMOTION_618: "promotion_618"
} as const;

export type ActivityType = (typeof ACTIVITY_TYPE)[keyof typeof ACTIVITY_TYPE];

export const CURRENT_POWER_ACTIVITY_TYPE = ACTIVITY_TYPE.PROMOTION_618;
